import { Input } from "@sagot/ui";
import { useState } from "react";

interface IntegerInputProps {
  value: number;
  min: number;
  max: number;
  disabled?: boolean;
  id?: string;
  className?: string;
  "aria-label"?: string;
  onChange: (value: number) => void;
}

const clamp = (value: number, min: number, max: number): number => Math.min(Math.max(value, min), max);

/**
 * A whole-number field that can be cleared while typing: the text is kept locally, every valid
 * entry is reported already clamped to `min`..`max`, and the field shows the committed value again on blur.
 */
export function IntegerInput({ value, min, max, disabled, id, className, "aria-label": ariaLabel, onChange }: IntegerInputProps) {
  const [draft, setDraft] = useState<string | null>(null);
  return (
    <Input
      id={id}
      className={className}
      aria-label={ariaLabel}
      inputMode="numeric"
      autoComplete="off"
      disabled={disabled}
      value={draft ?? String(value)}
      onChange={(event) => {
        const digits = event.target.value.replace(/\D/g, "").slice(0, String(max).length);
        setDraft(digits);
        if (digits) onChange(clamp(Number(digits), min, max));
      }}
      onBlur={() => { setDraft(null); }}
    />
  );
}
